import { Button, Empty, Form, Radio, Spin, Tooltip } from 'antd'
import { useEffect, useState } from 'react'
import { SDrawerOrModal, SSkuCard } from 'shj-components'
import styles from './index.module.less'
import DoubleDown from '@/assets/DoubleDown.svg'
import { cloneDeep, isArray } from 'lodash-es'
import noData from '@/assets/noData.png'
export default function ModifyStandard(props) {
  const { formList, onSubmit, loading, skuList, okText, record } = props
  const [list, setList] = useState<any>([])
  const [form] = Form.useForm()
  const [btnLoading, setBtnLoading] = useState(false)
  const [currentSku, setCurrentSku] = useState<any>(null)
  console.log(record, 'record')
  useEffect(() => {
    setList(formList)
  }, [])
  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }
  // 初始化
  useEffect(() => {
    console.log(formList, 'formList')
    if (isArray(formList) && formList?.length > 0) {
      if (formList.length === 1) {
        // 处理只有一种的情况
        let el = formList[0]
        el.options.map((option: any) => {
          let canbechoose = skuList?.find(sku => sku.argMap[el.argCode].valueId === option.valueId)
          if (canbechoose) {
            option.disabled = false
          } else {
            option.disabled = true
          }
        })
      }
      formList.map(item => {
        if (!item.argValId) {
          form.setFieldsValue({
            [item.argCode]: item.options[0]?.argValId,
          })
          item.argValId = item.options[0]?.argValId
          item.argValName = item.options[0]?.argValName
          // 默认触发一次
          argChange(item, item.options[0]?.argValId, 0, 'init')
        } else {
          form.setFieldsValue({
            [item.argCode]: item.argValId,
          })
          argChange(item, item.argValId, 0, 'init')
        }
        item.options.map(option => {
          return {
            ...option,
            disabled: false,
          }
        })
      })
    } else {
      setList([])
    }
    // setList(formList)
  }, [formList])

  const { open, title } = props
  const onSubmitModal = async () => {
    setBtnLoading(true)
    try {
      await onSubmit(list)
      setBtnLoading(false)
    } catch (error) {
      setBtnLoading(false)
    }
    props.onCancel()
  }

  // 定义一个函数，用于处理参数变化
  const argChange = (item, value, index, type) => {
    let newList: any = type === 'init' ? [...formList] : [...list]
    newList.forEach((el: any) => {
      if (el.argCode === item.argCode) {
        // 当前选中的不处理禁用状态
        let optionValue = el.options?.find((option: any) => option.argValId === value)
        el.argValId = optionValue?.argValId
        el.argValName = optionValue?.argValName
        el.processDesc = optionValue?.processDesc // 添加当前选中的工艺说明
      } else {
        // 其他非当前选用的 需要判断是否禁用
        let canBeChooseSkulist = skuList.filter((sku: any) => {
          if (sku.argMap[item.argCode].valueId === value) {
            return sku
          }
        })
        el.options.map((option: any) => {
          let canbechoose = canBeChooseSkulist.find(
            sku => sku.argMap[el.argCode].valueId === option.valueId
          )
          if (canbechoose) {
            option.disabled = false
          } else {
            option.disabled = true
          }
        })
      }
    })
    console.log(newList, 'newList')
    let selectObj = {}
    let newSkuObj: any = {}
    newList.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key]?.valueId !== selectObj[key]?.argValId) {
          flag = false
        }
      }
      if (flag) {
        newSkuObj = item
      }
    })
    console.log(newSkuObj, 'newSkuObj')

    setCurrentSku(newSkuObj)
    setList([...newList])
  }

  const showNationalTagRender = (item: any) => {
    let showTags = item?.productSpu?.skuList?.find(
      (sku: any) => sku.id === currentSku?.id
    )?.showTags
    if (showTags && isArray(showTags)) {
      return showTags?.map((tag: any) => {
        return (
          <div className={tagsMap[tag.tagCode]}>
            <Tooltip placement="topLeft" title={tag.tagName}>
              {tag.tagName}
            </Tooltip>
          </div>
        )
      })
    } else {
      return <></>
    }
  }
  return (
    <SDrawerOrModal
      mode="modal"
      open={open}
      onCancel={() => {
        form.resetFields()
        props.onCancel()
      }}
      title={title}
      antdProps={{
        footer: (
          <>
            <Button
              key="back"
              onClick={() => {
                form.resetFields()
                props.onCancel()
              }}
            >
              取消
            </Button>
            <Button key="submit" type="primary" loading={btnLoading} onClick={onSubmitModal}>
              {okText ? '确定' : '加入选材车'}
            </Button>
          </>
        ),
      }}
    >
      <Spin spinning={loading}>
        <p className={styles.modifyModalSKuName}>
          {showNationalTagRender(record)}
          {currentSku?.skuName}
          {(currentSku?.priceInfo?.customerPrice || currentSku?.priceInfo?.customerPrice == 0) && (
            <p style={{ color: 'red', fontSize: '18px'}}>
              <span style={{ fontSize: '14px' }}>￥</span>
              {currentSku?.priceInfo?.customerPrice}/{currentSku?.unitInfo?.unitName}
            </p>
          )}
        </p>
        {open && (
          <>
            <Form
              form={form}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 18 }}
              layout="vertical"
              style={{ maxWidth: 600 }}
            >
              {list.map((item: any, index) => {
                return (
                  <Form.Item label={item.argName} name={item.argCode} key={item.argCode}>
                    <p
                      style={{
                        marginTop: '-8px',
                        marginBottom: '5px',
                        fontSize: '12px',
                        color: '#999',
                      }}
                    >
                      {item?.processDesc || ''}
                    </p>
                    <Radio.Group
                      onChange={e => argChange(item, e.target.value, index, 'edit')}
                      value={item.argValId}
                      options={item?.options?.map((option: any) => {
                        return {
                          label: option.argValName,
                          value: option.argValId,
                          disabled: option.disabled,
                        }
                      })}
                    />
                  </Form.Item>
                )
              })}
            </Form>
            {!list.length && <Empty image={noData} imageStyle={{ height: 100 }}></Empty>}
          </>
        )}
      </Spin>
    </SDrawerOrModal>
  )
}
